// extracted by mini-css-extract-plugin
export default {"baseButton":"Button_baseButton__0uxQX","hiddenButton":"Button_hiddenButton__AeSwG","rightIcon":"Button_rightIcon__ks+es","leftIcon":"Button_leftIcon__3-lv2"};